import { MapPin, Github, Mail, Linkedin } from 'lucide-react';

export const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'Projects', to: '/projects' },
  { label: 'Resume', to: '/resume' },
  { label: 'Contact', to: '/contact' },
];

export const highlightStats = [
  { label: 'Location', value: 'North Carolina, USA', icon: MapPin },
  { label: 'Focus', value: 'AI · ML · Data Systems' },
  { label: 'Latest build', value: 'Truth Table Generator', link: 'https://truthtable.andrewbarber.dev' }
];

export const focusAreas = [
  {
    title: 'AI + Computer Vision',
    description: 'Motion-controlled games, gesture interfaces, and realtime experimentation with cv2, MediaPipe, and TensorFlow.',
  },
  {
    title: 'Developer Tools',
    description: 'Designing approachable utilities that make coding friendlier for new builders, GUIs, package helpers, and teaching demos.',
  }
];

export const projects = [
  {
    title: 'AI Hand Tracking Ping Pong Game',
    description: 'Play ping pong with nothing but a webcam. Computer vision tracks your hands in realtime for paddle control.',
    link: 'https://github.com/arjbarber/pingpong',
    tech: ['Python', 'OpenCV', 'MediaPipe', 'AI']
  },
  {
    title: 'pipim',
    description: 'A beginner friendly desktop GUI for managing Python packages. Install, remove, and search without touching the CLI.',
    link: 'https://github.com/arjbarber/pipim',
    tech: ['Python', 'Tkinter', 'Package Management']
  },
  {
    title: 'Translator App',
    description: 'Simple translator that wraps a pretrained AI model with a clean interface for quick, offline friendly usage.',
    link: 'https://github.com/arjbarber/translator',
    tech: ['Python', 'AI', 'NLP']
  },
  {
    title: 'Lottery Predictor',
    description: 'Data pipeline + TensorFlow model that visualizes past lottery draws and prototypes prediction ideas.',
    link: 'https://github.com/arjbarber/lottery-genie',
    tech: ['Python', 'TensorFlow', 'Data Analysis']
  },
  {
    title: 'In Real Life Platformer',
    description: 'A Doodle Jump–style game you control by moving in real life (cv2 + mediapipe). Jump on platforms by physically moving your body!',
    link: 'https://github.com/arjbarber/irl-platformer',
    tech: ['Python', 'OpenCV', 'MediaPipe', 'Gaming']
  },
  {
    title: 'Truth Table Generator',
    description: 'A truth table generator which simplifies boolean expressions. Built with React and hosted on Cloudflare Pages.',
    link: 'https://truthtable.andrewbarber.dev',
    tech: ['HTML/CSS', 'JavaScript', 'React', 'DNS/Hosting', 'APIs', 'Cloudflare Functions']
  }
];

export const skillGroups = [
  {
    title: 'Languages',
    items: [
      { name: 'Python', link: 'https://www.python.org/' },
      { name: 'Java', link: 'https://www.java.com/en/' },
      { name: 'C', link: 'https://devdocs.io/c/' },
      { name: 'C++', link: 'https://cppreference.com/' },
      { name: 'HTML/CSS', link: 'https://developer.mozilla.org/en-US/docs/Web/HTML' },
      { name: 'JavaScript', link: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript' },
      { name: 'Swift', link: 'https://swift.org/' }
    ]
  },
  {
    title: 'Frameworks',
    items: [
      { name: 'Flask', link: 'https://flask.palletsprojects.com/en/stable/' },
      { name: 'React', link: 'https://react.dev/' },
      { name: 'TensorFlow', link: 'https://www.tensorflow.org/' },
      { name: 'Pygame', link: 'https://www.pygame.org/docs/' },
      { name: 'MediaPipe', link: 'https://ai.google.dev/edge/mediapipe/solutions/guide' },
      { name: 'Tkinter', link: 'https://docs.python.org/3/library/tkinter.html' },
      { name: 'SwiftUI', link: 'https://developer.apple.com/documentation/SwiftUI' }
    ]
  },
  {
    title: 'Tools',
    items: [
      { name: 'Git', link: 'https://git-scm.com/docs' },
      { name: 'VS Code', link: 'https://code.visualstudio.com/' },
      { name: 'Xcode', link: 'https://developer.apple.com/xcode/' }
    ]
  }
];

export const contactLinks = [
  { label: 'Email', href: 'mailto:arjbarber@gmail.com', icon: Mail },
  { label: 'GitHub', href: 'https://github.com/arjbarber', icon: Github },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/andrewbarber08/', icon: Linkedin }
];
